import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import AddchartOutlinedIcon from "@mui/icons-material/AddchartOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PeopleAltSharpIcon from "@mui/icons-material/PeopleAltSharp";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import EditIcon from "@mui/icons-material/Edit";
import Diversity3Icon from '@mui/icons-material/Diversity3';

import { selectItem } from "../../store/layoutDashboard/layoutSlice";

export const MenuListDrawer = ({ size }) => {
  const { role } = useSelector((state) => state.auth);
  const { t } = useTranslation("global");
  const [position, setPosition] = useState(["white", "info"]);
  const [opportunities, setOpportunities] = useState(["white", "info"]);
  const [events, setEvents] = useState(["white", "info"]);
  const [individuals, setIndividuals] = useState(["white", "info"]);
  const [startup, setStartup] = useState(["white", "info"]);
  const [vehicles, setVehicles] = useState(["white", "info"]);
  const [divestments, setDivestments] = useState(["white", "info"]);
  const [landingEdit, setLandingEdit] = useState(["white", "info"]);
  const [networking, setNetworking] = useState(["white", "info"]);
  const navigate = useNavigate();

  const { itemSelected } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  useEffect(() => {
    const pathName = window.location.pathname;
    if (pathName === "/partners" || pathName === "/addpartner") {
      setIndividuals(["#EA7F22", "secondary"]);
    } else if (
      pathName === "/positions" ||
      pathName === "/addPositions" ||
      pathName === "/positionsViews" ||
      pathName === "/createRound"
    ) {
      setPosition(["#EA7F22", "secondary"]);
    } else if (
      pathName === "/opportunities" ||
      pathName === "/addOpportunities" ||
      pathName === "/reservation" ||
      pathName === "/opportunityViews"
    ) {
      setOpportunities(["#EA7F22", "secondary"]);
    } else if (
      pathName === "/events" ||
      pathName === "/addEvent" ||
      pathName === "/viewRegistered" ||
      pathName === "/addRegisteredEvent"
    ) {
      setEvents(["#EA7F22", "secondary"]);
    } else if (pathName === "/startup" || pathName === "/addStartup") {
      setStartup(["#EA7F22", "secondary"]);
    } else if (pathName === "/vehicle" || pathName === "/addVehicle") {
      setVehicles(["#EA7F22", "secondary"]);
    } else if (
      pathName === "/positionsLP" ||
      pathName === "/addDivestments" ||
      pathName === "/viewFunds"
    ) {
      setDivestments(["#EA7F22", "secondary"]);
    } else if (pathName === "/landingEdit") {
      setLandingEdit(["#EA7F22", "secondary"]);
    } else if (pathName === "/networking") {
      setNetworking(["#EA7F22", "secondary"]);
    } else {
      setEvents(["white", "info"]);
      setIndividuals(["white", "info"]);
      setPosition(["white", "info"]);
      setOpportunities(["white", "info"]);
      setVehicles(["white", "info"]);
    }
  }, [itemSelected]);

  const onClick = (item) => {
    dispatch(selectItem(item));
    navigate(`/${item}`);
  };

  return (
    <List
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        marginTop: "15px",
      }}
    >
      {role === "Admin" && (
        <>
          <ListItem
            button
            sx={{ color: individuals[0] }}
            onClick={() => onClick("partners")}
          >
            <ListItemIcon>
              <PeopleAltSharpIcon color={individuals[1]} />
            </ListItemIcon>
            {size === "big" && (
              <ListItemText>{t("drawer.partners")}</ListItemText>
            )}
          </ListItem>
          <ListItem
            button
            sx={{ color: startup[0] }}
            onClick={() => onClick("startup")}
          >
            <ListItemIcon>
              <StoreOutlinedIcon color={startup[1]} />
            </ListItemIcon>
            {size === "big" && <ListItemText>Startups</ListItemText>}
          </ListItem>
          <ListItem
            button
            sx={{ color: vehicles[0] }}
            onClick={() => onClick("vehicle")}
          >
            <ListItemIcon>
              <ManageAccountsIcon color={vehicles[1]} />
            </ListItemIcon>
            {size === "big" && (
              <ListItemText>{t("drawer.vehicles")}</ListItemText>
            )}
          </ListItem>
        </>
      )}
      {role !== "LP" && (
        <ListItem
          button
          sx={{ color: opportunities[0] }}
          onClick={() => onClick("opportunities")}
        >
          <ListItemIcon>
            <AddchartOutlinedIcon color={opportunities[1]} />
          </ListItemIcon>
          {size === "big" && (
            <ListItemText>{t("drawer.opportunitiesItems")}</ListItemText>
          )}
        </ListItem>
      )}

      <ListItem
        button
        sx={{ color: events[0] }}
        onClick={() => onClick("events")}
      >
        <ListItemIcon>
          <CalendarMonthOutlinedIcon color={events[1]} />
        </ListItemIcon>
        {size === "big" && (
          <ListItemText>{t("drawer.eventsItems")}</ListItemText>
        )}
      </ListItem>

      {(role === "Club" || role === "Híbrido" || role === "Admin") && (
        <ListItem
          button
          sx={{ color: position[0] }}
          onClick={() => onClick("positions")}
        >
          <ListItemIcon>
            <InsertChartOutlinedIcon color={position[1]} />
          </ListItemIcon>
          {size === "big" && (
            <ListItemText>{t("drawer.positionItems")}</ListItemText>
          )}
        </ListItem>
      )}

      {(role === "LP" || role === "Híbrido" || role === "Admin" || role === "Club") && (
        <ListItem
          button
          sx={{ color: divestments[0] }}
          onClick={() => onClick("positionsLP")}
        >
          <ListItemIcon>
            <InsertChartOutlinedIcon color={divestments[1]} />
          </ListItemIcon>
          {size === "big" && (
            <ListItemText>{t("drawer.divestments")}</ListItemText>
          )}
        </ListItem>
      )}
      {role === "Admin" && (
        <ListItem
          button
          sx={{ color: landingEdit[0] }}
          onClick={() => onClick("landingEdit")}
        >
          <ListItemIcon>
            <EditIcon color={landingEdit[1]} />
          </ListItemIcon>
          {size === "big" && (
            <ListItemText>{t("drawer.landingEdit")}</ListItemText>
          )}
        </ListItem>
      )}
      <ListItem
        button
        sx={{ color: networking[0] }}
        onClick={() => onClick("networking")}
      >
        <ListItemIcon>
          <Diversity3Icon color={networking[1]} />
        </ListItemIcon>
        {size === "big" && (
          <ListItemText>{t("drawer.networking")}</ListItemText>
        )}
      </ListItem>
    </List>
  );
};
